import { z } from 'zod/v3';

export const ModifiedBySchema = z.object({
  id: z.number(),
  username: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
});

export const EntitySchema = z.object({
  id: z.number().readonly(),
  createdAt: z.string().nullable(),
  createdBy: ModifiedBySchema.nullable(),
  modifiedAt: z.string().nullable(),
  modifiedBy: ModifiedBySchema.nullable(),
});

export type ModifiedByType = z.infer<typeof ModifiedBySchema>;
